import "./styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { useSelector, useDispatch } from "react-redux";
import { addToCart, decrementQuantity } from "../../redux/slices/basketSlice";
import { RootState } from "../../redux/store";
import {
  setSelectedFood,
  toggleFoodDetailModal,
  toggleOutOfServiceModal,
} from "../../redux/slices/appSlice";
import { IMAGES_BASE_URL } from "../../utils/useFetch";
// import { LazyLoadImage } from "react-lazy-load-image-component";
// import TiaraLogo from "../../assets/images/logo_tiara.png";

const FoodCard = ({ data: foodData }: any) => {
  const dispatch = useDispatch();
  const basket = useSelector((state: RootState) => state.basket);
  const foodInCart = basket.cart.find((item: any) => item.id === foodData.id);
  const isOutOfServiceTime = useSelector(
    (store: RootState) => store.app.isOutOfServiceTime
  );

  const isAppOutOfService = useSelector(
    (store: RootState) => store.app.isAppOutOfService
  );

  const onCardClickHandle = () => {
    dispatch(setSelectedFood(foodData));
    dispatch(toggleFoodDetailModal());
  };

  const onPlusClickHandle = (e: any) => {
    e.stopPropagation();
    if (isOutOfServiceTime || isAppOutOfService) {
      dispatch(toggleOutOfServiceModal());
      return;
    }
    dispatch(addToCart(foodData));
  };

  const onMinusClickHandle = (e: any) => {
    e.stopPropagation();
    if (isOutOfServiceTime || isAppOutOfService) {
      dispatch(toggleOutOfServiceModal());
      return;
    }
    dispatch(decrementQuantity(foodData.id));
  };

  return (
    <div
      className='food-card'
      onClick={onCardClickHandle}
    >
      <div className='border rounded m-2'>
        <div>
          {/* <LazyLoadImage
            alt={foodData.name}
            effect='opacity'
            className='rounded w-full'
            src={IMAGES_BASE_URL + foodData.image}
            // afterLoad={() => setIsLoaded(true)}
            beforeLoad={() => setIsLoaded(true)}
          /> */}

          <img
            alt={foodData.name}
            className='rounded w-full'
            src={IMAGES_BASE_URL + foodData.image}
          />
        </div>
        <div className='font-bold m-2 mt-4'>{foodData.name}</div>
        <div className='flex m-2 items-center'>
          <div className='flex-1'>
            {`${new Intl.NumberFormat("fa-IR").format(foodData.price)} ریال`}
          </div>
          <div className='flex align-center '>
            {foodData.day_meals_left === 0 && (
              <span className='px-2 flex items-center	text-gray-400 border rounded py-1'>
                تمام شد!
              </span>
            )}

            {foodData.day_meals_left !== 0 && (
              <>
                <span
                  className='bg-rose-900 rounded p-2 flex text-white'
                  onClick={onPlusClickHandle}
                >
                  <FontAwesomeIcon icon={faPlus} />
                </span>
                {foodInCart && (
                  <span className='px-2 flex items-center	'>
                    {foodInCart.quantity}
                  </span>
                )}
                {foodInCart && (
                  <span
                    className='bg-gray-500 rounded p-2 flex text-white'
                    onClick={onMinusClickHandle}
                  >
                    <FontAwesomeIcon icon={faMinus} />
                  </span>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FoodCard;
